export default [
  {
    name: '李丰',
    title: `峰瑞资本
创始合伙人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/lifeng.png',
  },

  {
    name: '李翔',
    title: `得到总编辑
资深媒体人`,
       avatar:
       'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/lixiang.png',
   },
   
  {
    name: '惠若琪',
    title: `191运动空间创始人
惠动乐体育教育CEO
排球奥运冠军`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/huiruoqi.png',
  },
  {
    name: '丁长峰',
    title: `万科集团高级副总裁
酒店和度假事业部CEO`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/dingchangfeng.png',
  },
    {
    name: '蔡赟',
    title: `羽毛球奥运冠军
「超氧」品牌创始人	`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/caiyun.png',
  },
  {
    name: '郑析祺',
    title: `中金资本
副总经理`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/zhengxiqi.png',
  },
  {
    name: '金亦波',
    title: `腾讯游戏K6合作部副总经理
腾竞体育CEO `,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/jinyibo.png',
  },
  
  {
    name: '徐莉佳',
    title: `帆船奥运冠军
伦敦奥运会闭幕式旗手`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/xulijia.png',
  },
  {
    name: '庞伟',
    title: `10米气手枪
奥运冠军`,
       avatar:
       'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/pangwei.png',
   },
   {
    name: '陈屹',
    title: `环球律师事务所
合伙人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/chenyi.png',
  },
   {
    name: '庄明浩',
    title: `趣丸网络
副总裁`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/zhuangminghao.png',
  },
  {
    name: '靳星',
    title: `东方启明星体育教育
创始人、总裁`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/jinxing.png',
  },
  {
    name: '张涛',
    title: `万国体育
CEO`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/zhangtao.png',
  },

  {
    name: '王磊',
    title: `资深音乐人
湖南卫视《歌手》专家评委`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/wanglei.png',
  },
  {
    name: '余星宇',
    title: `力盛赛车
CEO`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/yuxingyu.png',
  },
  {
    name: '杨仲骁',
    title: `迪卡侬中国
冰雪运动发展总监`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/yangzhongxiao.png',
  },
  {
    name: '赵迪',
    title: `为先体育
创始人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/zhaodi.png',
  },
  {
    name: '吴少雍',
    title: `ACE PLAYER
创始人`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/wushaoyong.png',
  },
  {
    name: '李姝霖',
    title: `瀚动体育传媒
创始人兼CEO`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/lishulin.png',
  },

  {
    name: '续秋麟',
    title: `Keep
食品业务总经理`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/xuqiulin.png',
  },
  {
    name: '叶凯',
    title: `SNOW51
创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/yekai.png',
  },
  {
    name: '刘建宏',
    title: `凯利时科技董事长、CEO
开承体育董事长`,
    avatar:
      'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/liujianhong.png',
  },

  {
    name: '韩牧',
    title: `懒熊体育
创始人、CEO`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/hanmu.png',
  },

  {
    name: '黎双富',
    title: `懒熊体育
联合创始人、总裁`,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/lishuangfu.png',
  },
  {
    name: '张兵',
    title: `懒熊体育
副总裁`,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2021/guests/zhangbing.png',
  },

];
